import { Component, OnInit } from '@angular/core';
import { CustomSnackbarService } from '../../services/custom-snackbar.service';
import { HelpCenterService } from 'src/services/help-center.service';
import { MainTitle } from 'src/models/main-title';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-help-center',
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.scss']
})
export class HelpCenterComponent implements OnInit {
  public title = new MainTitle('HelpCenterComponent.shortTitle');

  /**
   * Displayed columns for processes tables
   */
  public helpCenterSettingsColumns: string[] = ['displayName', 'enabled'];

  /**
   * Datasource
   */
  public helpCenterSettingsDataSource = new MatTableDataSource<any>([]);

  constructor(
    private helpCenterService: HelpCenterService,
    private snackBarService: CustomSnackbarService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.helpCenterService.getHelpCenterSettings().subscribe((data) => {
      this.helpCenterSettingsDataSource.data = Array.from(data.items);
    });
  }

  saveSettings(): void {
    const data = this.helpCenterSettingsDataSource.filteredData;
    this.helpCenterService.updateHelpCenterSettings(data).subscribe(
      (_) => {
        this.snackBarService.present('Settings successfully saved');
      },
      (err) => {
        this.snackBarService.present(`ERROR ${err.status}: ${err.message}`);
      }
    );
  }
}
